export const mapPendingOrderAdressToAddress = (pendingOrderAddress: any) => {
  delete pendingOrderAddress['pricing'];
  delete pendingOrderAddress['deliveryPrice'];

  return pendingOrderAddress;
};
